//frontend/src/components/client/ClientFooter.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../axios';
import { 
  FaPhone, FaEnvelope, FaFacebook, 
  FaMapMarkerAlt, FaGlobe 
} from 'react-icons/fa';

const ClientFooter = () => {
  const currentYear = new Date().getFullYear();
  
  // Settings state
  const [settings, setSettings] = useState({
    client_logo: '/logo.png',
    client_company_name: 'ЖИМ-ГҮН КАРГО',
    client_description: 'Солонгос-Монгол хооронд найдвартай, хурдан, хямд үнээр ачаа тээвэрлэх үйлчилгээ',
    client_facebook_url: 'https://www.facebook.com/jimguncargo',
    client_website_url: 'https://jimguntrade.com'
  });

  // Footer contacts state
  const [footerContacts, setFooterContacts] = useState({
    korea_phone_1: '070-8018-8678',
    korea_phone_2: '010-5815-3005',
    korea_phone_3: '010-8088-2005',
    mongolia_phone_1: '(+976) 7786-8678',
    mongolia_phone_2: '(+976) 7788-3482',
    mongolia_phone_3: '(+976) 8888-3482',
    email: 'jimguncargo@gmail.com'
  });

  // Fetch settings and footer contacts
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axiosInstance.get('/api/settings/public/all');
        if (response.data.success) {
          const data = response.data.data;
          
          // Update general settings
          setSettings(prev => ({ ...prev, ...data }));
          
          // Extract and update footer contacts
          const contacts = {};
          Object.keys(data).forEach(key => {
            if (key.startsWith('footer_contact_')) {
              const contactKey = key.replace('footer_contact_', '');
              contacts[contactKey] = data[key];
            }
          });
          
          if (Object.keys(contacts).length > 0) {
            setFooterContacts(prev => ({ ...prev, ...contacts }));
          }
        }
      } catch (error) {
        console.error('Fetch footer settings error:', error);
        // Алдаа гарвал default утгуудыг ашиглах
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="client-footer">
      <div className="footer-main">
        <div className="footer-container">
          {/* COMPANY INFO */}
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src={settings.client_logo || '/logo.png'} 
                alt={settings.client_company_name}
                className="footer-logo-img"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'block';
                }}
              />
              <div className="footer-logo-fallback" style={{ display: 'none' }}>
                🚛
              </div>
            </div>
            <h3 className="footer-company-name">{settings.client_company_name}</h3>
            <p className="footer-company-desc">
              {settings.client_description}
            </p>
            <div className="footer-social">
              {settings.client_facebook_url && (
                <a 
                  href={settings.client_facebook_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label="Facebook"
                >
                  <FaFacebook />
                </a>
              )}
              {settings.client_website_url && (
                <a 
                  href={settings.client_website_url} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label="Website"
                >
                  <FaGlobe />
                </a>
              )}
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="footer-section">
            <h4 className="footer-title">Цэс</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">Нүүр хуудас</Link>
              </li>
              <li>
                <Link to="/tracking" className="footer-link">Ачаа хайх</Link>
              </li>
              <li>
                <Link to="/login" className="footer-link">Админ нэвтрэх</Link>
              </li>
            </ul>
          </div>

          {/* KOREA CONTACT */}
          <div className="footer-section">
            <h4 className="footer-title">
              <FaPhone className="inline mr-2" />
              Солонгос
            </h4>
            <ul className="footer-contact-list">
              {footerContacts.korea_phone_1 && (
                <li>📞 {footerContacts.korea_phone_1}</li>
              )}
              {footerContacts.korea_phone_2 && (
                <li>📞 {footerContacts.korea_phone_2}</li>
              )}
              {footerContacts.korea_phone_3 && (
                <li>📞 {footerContacts.korea_phone_3}</li>
              )}
            </ul>
          </div>

          {/* MONGOLIA CONTACT */}
          <div className="footer-section">
            <h4 className="footer-title">
              <FaMapMarkerAlt className="inline mr-2" />
              Монгол
            </h4>
            <ul className="footer-contact-list">
              {footerContacts.mongolia_phone_1 && (
                <li>📞 {footerContacts.mongolia_phone_1}</li>
              )}
              {footerContacts.mongolia_phone_2 && (
                <li>📞 {footerContacts.mongolia_phone_2}</li>
              )}
              {footerContacts.mongolia_phone_3 && (
                <li>📞 {footerContacts.mongolia_phone_3}</li>
              )}
              {footerContacts.email && (
                <li className="mt-2">
                  <FaEnvelope className="inline mr-2" />
                  {footerContacts.email}
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <div className="footer-container">
          <p className="footer-copyright">
            © {currentYear} Жим-гүн Карго. Бүх эрх хуулиар хамгаалагдсан.
          </p>
          <p className="footer-powered">
            Cargo Logistics System • Developed by NG • +976-9505-1944
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ClientFooter;